module.exports = __webpack_public_path__ + "img/goodYear.f289582c.png";